import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/water-intake-calculator',
  component: () => import('../../routes/WaterIntakeCalculator.svelte'),
  card: {
    id: 'water-intake-calculator',
    title: 'Water Intake Calculator',
    description: 'Calculate how much water you should drink daily based on your weight, activity level, and climate.',
    icon: 'water_drop',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/water-intake-calculator',
    category: 'Weight & Nutrition',
  },
  seo: {
    title: 'Water Intake Calculator – Daily Hydration Needs',
    description: 'Free water intake calculator to find how much water you should drink daily. Enter your weight, activity level, and climate to get your personalized hydration goal in ounces, liters, and glasses.',
  },
};

export default meta;
